import React from "react";
import { Link } from "react-router-dom";
import ArrowLeft from "@/assets/icons/LeftArrowGray.svg";

const BackToProjects = () => {
  return (
    <div className="z-50 fixed w-full bg-white py-5 px-4 shadow-sm">
      <div className="flex justify-between items-center">
        <Link
          to="/projects"
          className="flex gap-2 items-center text-[#48535B] text-sm font-medium"
        >
          <ArrowLeft />
          <p className=" md:block hidden">Back to projects</p>
        </Link>
        {/* <div className="text-sm leading-5 tracking-[-1%] flex items-center gap-5 md:hidden">
          <p className="text-[#6941C6]">View activity</p>
          <p className="text-[#667085]">Help</p>
        </div> */}
      </div>
    </div>
  );
};

export default BackToProjects;
